import { useState, useEffect } from "react";
import I18n from "common/i18n";
import { useScale, useLocalizedImage } from "common/utils";
import { Layout, Overlay } from "features/creator/tutorial/top/stages/Layout";
import { Title } from "../Title";

const Step = (props: { back: () => void; next: () => void; close: () => void }) => {
  const { scale } = useScale();
  const { back, next, close } = props;
  const localizedImage = useLocalizedImage();
  const [panelRect, setPanelRect] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    setTimeout(() => {
      const panel = document.getElementById("creator-ranking-btn");
      const rect = panel.getBoundingClientRect();
      setPanelRect({
        x: rect.x,
        y: rect.y - 40 * scale,
        width: rect.width + 20 * scale,
        height: rect.width + 20 * scale,
      });
    }, 300);
  }, [scale]);

  return (
    <>
      <Overlay area={panelRect}>
        <></>
      </Overlay>

      <Layout transparent back={back} next={next} close={close}>
        <Title activeStep={6} />

        <div className="flex-col-el items-start justify-center w-[312px]">
          <img
            alt="pick up title"
            src={localizedImage("title_text_ranking")}
            className="w-[150px] h-[45px]"
          />

          <p className="text-body text-textcolor-black text-[22px] whitespace-pre">
            {I18n.locale === "ja"
              ? "にんきの アプリや\nちゅうもく プレイヤーの\nランキングを\nみることが できます。"
              : "人気のアプリや\n注目プレイヤーの\nランキングを\n見ることができます。"}
          </p>
        </div>
      </Layout>
    </>
  );
};

export default Step;
